import { cleanNumber } from "helpers/cleanNumbers";
import { newDateWithTime } from "helpers/dateTools";
import { extractIDs } from "helpers/extractIDs";
import { useValidateReload } from "hooks/useValidateReload";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  sendCashInvoices,
  getBillingReasons,
  restart,
} from "redux/actions/invoices/invoicesCashAction";
import { reasonNotesOptions } from "./config"

export const useCashInvoicesHook = ({
  notes, dataToSend, resume, billingReasons, reasonSelect, date, clearForm, noteUnification
}) => {
  const { iva, total, subTotal } = resume
  const base = "loadingInvoices";
  const loadings = [
    `${base}UnificationNote`,
    `${base}BillingReasons`,
    `${base}Series`,
  ];
  useValidateReload(loadings);
  const { stationsList } = useSelector(({ companies }) => companies)
  const [isReady, setIsReady] = useState(false);

  const handleSubmit = () => {
    const hasGrouped = notes[0].grouped?.val;
    const ivaSelected = notes[0].ivaLabel * 100;
    const totalQuantity = notes.reduce((acc, curr) => {
      let acc_ = cleanNumber(acc?.quantity)
      let curr_ = cleanNumber(curr?.quantity)
      return acc_ += curr_
    }, 0)
    let form = {
      idReason: notes[0].idReason,
      iva: cleanNumber(ivaSelected),
      subTotal: cleanNumber(subTotal),
      totalIVA: cleanNumber(iva),
      total: cleanNumber(total),
      quantity: totalQuantity,
      price: notes[0].priceWithIva,
      issuer: {
        idCompany: dataToSend?.transmitter.idCompany,
        rfc: dataToSend?.transmitter.rfc,
      },
      receiver: dataToSend?.receiver,
      idSerie: dataToSend?.transmitter.idSerie,
      creLicense: dataToSend?.transmitter.creLicense,
      issueDate: newDateWithTime({ date: date, format: true }) || newDateWithTime({ format: true }),
      certificationDate: newDateWithTime({ format: true }),
      paymentType: dataToSend?.receiver.paymentType,
      paymentMethod: dataToSend?.receiver.paymentMethod,
      logo: dataToSend?.transmitter.logo,
      invoiceConcept: dataToSend?.transmitter.invoiceConcept,
      observations: dataToSend?.comments.observations,
      email: dataToSend?.receiver.email,
      grouped: hasGrouped,
    }

    if (reasonSelect === reasonNotesOptions.advances || (reasonSelect === reasonNotesOptions.foreign && !noteUnification?.id)) {
      form = {
        ...form,
        folio: notes[0].folio,
      };
    }
    else {
      const { notesDetails, notesSimple } = notes.reduce(
        (acc, item) => {
          if (item.details) acc.notesDetails.push(item.details);
          else acc.notesSimple.push(item);
          return acc;
        },
        { notesDetails: [], notesSimple: [] }
      );
      form = {
        ...form,
        ...(notesSimple.length && { idNotes: extractIDs(notesSimple) }),
        ...(notesDetails.length && { sNoteDetails: notesDetails })
      };
    }
    dispatch(sendCashInvoices(form))
  }

  useEffect(() => {
    if (dataToSend?.transmitter && dataToSend?.receiver && notes.length > 0) {
      setIsReady(true);
    } else {
      setIsReady(false);
    }
  }, [dataToSend]);

  const dispatch = useDispatch();
  useEffect(() => {
    if (stationsList.length > 0) {
      billingReasons.length === 0 && dispatch(getBillingReasons())
    }
  }, [stationsList])

  useEffect(() => {
    if (clearForm) {
      dispatch(restart())
    }
  }, [clearForm])

  return {
    handleSubmit,
    isReady,
  }
}
